import React from "react";
import { Container } from "reactstrap";
import { PageHeader } from "@/CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { Col, Row, Space } from "antd";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowLeft01Icon,
  Briefcase06Icon,
  HajiIcon,
  PieChartIcon,
  UserRemove02Icon,
} from "@hugeicons/core-free-icons/index";
import { Link } from "react-router";

const CampaignsAndGroupsReports = () => {
  const { t } = useTranslation();

  const reports = [
    {
      key: "detailed-upcoming-groups-ands-campaigns-report",
      icon: UserRemove02Icon,
      title: t("DETAILED_UPCOMING_GROUPS_ANDS_CAMPAIGNS_REPORT"),
      to: "detailed-upcoming-groups-ands-campaigns-report",
    },
    {
      key: "pilgrim-mission-arriving-leaving-statistics-report",
      icon: UserRemove02Icon,
      title: t("PILGRIM_MISSION_ARRIVING_LEAVING_STATISTICS_REPORT"),
      to: "pilgrim-mission-arriving-leaving-statistics-report",
    },
    {
      key: "campaigns-and-groups-statement-report",
      icon: HajiIcon,
      title: t("CAMPAIGNS_AND_GROUPS_STATEMENT_REPORT"),
      to: "campaigns-and-groups-statement-report",
    },
  ];

  return (
    <div>
      <PageHeader title={t("CAMPAIGN_AND_GROUP_REPORTS")} sticky={false} />
      <Container fluid>
        <Row justify="start" gutter={[16, 16]}>
          {reports.map((report) => (
            <Col md={12} span={24} key={report.key}>
              <ReportCard key={report.key} {...report} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default CampaignsAndGroupsReports;

const ReportCard = (props) => {
  const { icon, title, to } = props;

  return (
    <Link
      to={to}
      className="rounded-4 border border-1 p-4 w-100 justify-content-between d-flex align-items-center"
    >
      <Space>
        <HugeiconsIcon className="d-flex" icon={icon} />
        <p className="m-0 fw-bold">{title}</p>
      </Space>

      <HugeiconsIcon icon={ArrowLeft01Icon} />
    </Link>
  );
};
